import forOwn from 'mout/object/forOwn'

/**
 * Set up the byItem scoring object.
 * @param {object} destructuredSubtests Created by destructureSubtests function. Contains arrays of subtest item ids.
 * @returns {object} byItem scoring object.
 */
export default function initializeByItemScoring(destructuredSubtests) {
  
  let byItem = {}

  forOwn(destructuredSubtests, (val, key, o) => {
    byItem[key] = {}
    val.items.forEach((item, n) => {
      byItem[key][item] = {
        itemId: item,
        possible: 1,
        raw: 0,
        complete: false,
        index: n,
      }
    })
  })

  return byItem

}


// WEBPACK FOOTER //
// ./src/helpers/assessment/initializeByItemScoring.js